import {ADD_TAG, DELETE_TAG, UPDATE_TAG} from '../actions/tags';
import {HANDLE_NEW_QDD} from '../actions/sync';
import generateID from './generateID';
import objectByID from './objectByID';

export default (state=[], action) => {
  switch (action.type) {
    case ADD_TAG: {
      return [
        ...state,
        {
          id: generateID(),
          label: action.label,
          section: action.section
        }
      ]
    }
    case DELETE_TAG: {
      const tag = objectByID(state, action.id);
      const index = state.indexOf(tag);
      return [
        ...state.slice(0, index),
        ...state.slice(index+1)
      ];
    }
    case UPDATE_TAG: {
      const tag = objectByID(state, action.id);
      const index = state.indexOf(tag);
      return [
        ...state.slice(0, index),
        {
          ...tag,
          label: action.label
        },
        ...state.slice(index+1)
      ];
    }
    case HANDLE_NEW_QDD: {
      return [
        ...action.payload.tags || []
      ]
    }
    default:
      return state;
  }
}
